export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SupportChat.vue?vue&type=template&id=6af4a4ad&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/SupportChat.vue?vue&type=template&id=6af4a4ad&scoped=true
// module id = 1642
// module chunks = 31